"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Typography_1 = require("../Typography");
var TextInputMenuItem = function (_a) {
    var item = _a.item, onClick = _a.onClick, active = _a.active;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: onClick, className: (0, classnames_1.default)("\n            squid-rounded-component-dropdown-menu-border-radius \n            squid-px-4 \n            squid-py-2 \n            squid-flex \n            squid-gap-2 \n            squid-items-center\n            squid-justify-between\n            ", {
            'squid-bg-alias-state-base-active': active,
            'active:squid-bg-alias-state-base-pressed': !active,
            'hover:squid-bg-alias-state-base-hover': !active,
        }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-flex-1 squid-flex-col squid-justify-start') }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: active, className: (0, classnames_1.default)('squid-whitespace-nowrap', active
                    ? 'squid-text-alias-color-text-on-active'
                    : 'squid-text-alias-color-text-weaker') }, { children: item.label })) })) })));
};
exports.default = TextInputMenuItem;
